<template>
  <article
    class="review-card"
    :class="rootClasses"
    :data-slider-item="isSlider ? '' : null"
    role="button"
    tabindex="0"
    @click="openModal(post)"
    @keydown.enter.prevent="openModal(post)"
    @keydown.space.prevent="openModal(post)"
  >
    <h3 v-if="post.title" class="review-card__title" v-text="post.title" />
    <review-stars
      class="review-card__stars"
      :count="starCount"
      :size="16"
      :aria-label="getStarLabel(post.rating)"
    />
    <p class="review-card__body" v-text="bodyText" />
    <div v-if="hasFooter" class="review-card__footer">
      <span v-if="customerName" class="review-card__name" v-text="customerName" />
      <span
        v-if="customerName && showDate"
        class="review-card__footer-divider"
        aria-hidden="true"
        >·</span
      >
      <span
        v-if="showDate"
        class="review-card__date"
        v-text="timeSinceDate(post.review_date)"
      />
    </div>
    <div v-if="showReply && post.reply" class="review-card__reply">
      <p v-text="texts.replyFromLavendla" />
      <p v-text="post.reply" />
    </div>
  </article>
</template>

<script>
import { mapActions } from 'vuex';
import { useDateFormatter } from 'Composables/useDateFormatter';
import { getStarLabel } from '../misc/helpers';
import ReviewStars from './ReviewStars.vue';

export default {
  name: 'ReviewCard',

  components: {
    ReviewStars,
  },

  props: {
    post: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: 'slider',
      validator: (value) => ['slider', 'card'].includes(value),
    },
    showReply: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    const { timeSinceDate } = useDateFormatter();
    return { timeSinceDate };
  },

  data() {
    return {
      texts: window.theme_vars.trustpilotArchive,
      hideReviewDate: !!window.theme_vars.hideReviewDate,
    };
  },

  computed: {
    isSlider() {
      return this.variant === 'slider';
    },

    rootClasses() {
      const classes = [`review-card--${this.variant}`];
      if (this.isSlider) {
        classes.push('lav-cards__card-wrapper');
      }
      return classes;
    },

    customerName() {
      return this.post.customer || this.post.customer_name || '';
    },

    showDate() {
      return !this.hideReviewDate && !!this.post.review_date;
    },

    hasFooter() {
      return !!this.customerName || this.showDate;
    },

    starCount() {
      const rating = Number(this.post.rating);
      return Math.round(Number.isFinite(rating) ? rating : 5);
    },

    bodyText() {
      const doc = new DOMParser().parseFromString(
        String(this.post.review || ''),
        'text/html',
      );
      return doc.body.textContent || '';
    },
  },

  methods: {
    ...mapActions('reviews', ['openModal']),

    getStarLabel,
  },
};
</script>
